(function () {
  var params = new URLSearchParams(window.location.search);
  var isEmbed = params.get('embed') === '1';
  // ?age_verified=1 is appended by the marketing site after its own gate
  // is passed, so a customer who clicked "Order a Bottle" from the marketing
  // site lands here with the gate auto-skipped.
  var isMarketingBypass = params.get('age_verified') === '1';

  /* ── Age gate ─────────────────────────────────────────────────
     Cross-storage helpers. Privacy-mode and sandboxed contexts throw
     on every localStorage call; sessionStorage is the per-tab fallback;
     an in-memory flag is the last resort. */
  var KEY = 'cw-age-ok';
  var memOK = false;
  function getOK() {
    try { if (localStorage.getItem(KEY) === '1') return true; } catch (e) {}
    try { if (sessionStorage.getItem(KEY) === '1') return true; } catch (e) {}
    return memOK;
  }
  function setOK() {
    try { localStorage.setItem(KEY, '1'); return; } catch (e) {}
    try { sessionStorage.setItem(KEY, '1'); return; } catch (e) {}
    memOK = true;
  }

  var gate = document.getElementById('age-gate');
  if (gate) {
    if (isEmbed || isMarketingBypass || getOK()) {
      if (isMarketingBypass) setOK();
      gate.remove();
    } else {
      var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
      var trap = function (e) {
        if (e.key !== 'Tab') return;
        var f = gate.querySelectorAll(FOCUSABLE);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
      var openGate = function () {
        gate.removeAttribute('inert');
        gate.setAttribute('aria-hidden', 'false');
        gate.classList.add('is-open');
        document.body.classList.add('age-gate-open');
        var firstBtn = gate.querySelector('[data-gate-yes]');
        if (firstBtn) firstBtn.focus();
        document.addEventListener('keydown', trap);
      };
      var closeGate = function () {
        gate.setAttribute('aria-hidden', 'true');
        gate.setAttribute('inert', '');
        gate.classList.remove('is-open');
        document.body.classList.remove('age-gate-open');
        document.removeEventListener('keydown', trap);
        var main = document.getElementById('MainContent');
        if (main) {
          main.setAttribute('tabindex', '-1');
          main.focus();
        }
      };
      var yes = gate.querySelector('[data-gate-yes]');
      var no = gate.querySelector('[data-gate-no]');
      if (yes) yes.addEventListener('click', function () {
        setOK();
        closeGate();
      });
      if (no) no.addEventListener('click', function () {
        window.location.href = 'https://www.responsibility.org/';
      });
      openGate();
    }
  }

  /* ── Cart drawer ── */
  var drawer = document.getElementById('cw-drawer');
  function openDrawer() {
    if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  }
  function closeDrawer() {
    if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  }

  if (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  var cartTrigger = document.getElementById('cw-cart-trigger');
  if (cartTrigger && drawer) {
    cartTrigger.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-hidden', cart.item_count === 0);
        });
      })
      .catch(function () {});
    var body = drawer && drawer.querySelector('[data-drawer-body]');
    if (body) {
      fetch('/?sections=cart-drawer-body')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data['cart-drawer-body']) body.innerHTML = data['cart-drawer-body'];
        })
        .catch(function () {});
    }
  }

  var buyForm = document.getElementById('cw-buy-form');
  if (buyForm) {
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(buyForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function () { refreshCart(); openDrawer(); })
        .catch(function () { buyForm.submit(); });
    });
  }

  /* ── Sticky header scrolled state ── */
  var nav = document.getElementById('cw-nav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Mobile nav panel ── */
  var burger = document.getElementById('cw-nav-burger');
  var panel = document.getElementById('cw-nav-panel');
  if (burger && panel) {
    var openPanel = function () {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nav-open');
    };
    var closePanel = function () {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-open');
    };
    burger.addEventListener('click', openPanel);
    panel.querySelectorAll('[data-nav-close]').forEach(function (el) {
      el.addEventListener('click', closePanel);
    });
    panel.querySelectorAll('a').forEach(function (el) {
      el.addEventListener('click', closePanel);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });
  }
})();
